<div class="widget container p-3 flex flex-column">
  <div class="flex justify-content-between">
    <app-svg-icon iconName="arrow_left" iconColor="primary" iconSize="xs" (click)="goBack()"></app-svg-icon>
  </div>

  <div class="flex flex-column gap-5 mt-4">
    <div class="flex flex-column gap-1">
      <span class="font-size-xl font-semibold">
        {{ "repairs.detail.notes" | translate }}
      </span>

      @if (repairRequest.notes) {
        <span> {{ repairRequest.notes }}</span>
      } @else {
        <span class="font-size-sm">
          {{ "repairs.detail.no_notes" | translate }}
        </span>
      }
    </div>

    <div class="flex flex-column gap-1">
      <span class="font-size-xl font-semibold">
        {{ "repairs.detail.fault_text" | translate }}
      </span>

      @if (repairRequest.gateFault?.faultText) {
        <span> {{ repairRequest.gateFault.faultText }}</span>
      } @else {
        <span class="font-size-sm">
          {{ "repairs.detail.no_notes" | translate }}
        </span>
      }
    </div>

    <div class="flex flex-column gap-1">
      <span class="font-size-xl font-semibold">
        {{ "repairs.detail.attachments" | translate }}
      </span>
      <div class="mt-4 imageList">
        @if (timeoutMedia()) {
          <div class="">
            <app-timeout></app-timeout>
          </div>
        } @else if (loadingMedia()) {
          <div class="h-full flex justify-content-center align-items-center">
            <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
          </div>
        } @else {
          @for (image of images; track image) {
            <app-image-list-item
              [config]="image"
              [hideDelete]="true"
              [hideEdit]="true"
              [hideLabel]="true"
              (openEvent)="downloadFile(image.link)"
            ></app-image-list-item>
          } @empty {
            <span class="font-size-sm">
              {{ "repairs.detail.no_attachments" | translate }}
            </span>
          }
        }
      </div>
    </div>
  </div>
</div>
